import React, { useState,useRef,useEffect } from 'react';
import SearchableVehicleSelect from './SearchableVehicleSelect'
import './MobileGrid.css'
import DetailComponentMobile from './DetailComponentMobile';
import {buildGetWebformRoutingDetails} from './XmlBuildFunctions'   
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faMap } from '@fortawesome/free-solid-svg-icons';

const MobileGrid = ({ route,vehicleData,vehiclechanged }) => { 
    const [expandedRowId, setExpandedRowId] = useState(null); 
    const [detailData, setdetailData] = useState([]);
    const intervals = useRef({}); 
    const [activeBTN, setactiveBTN] = useState({});       
    const handleToggleDetails = (id) => {  

        setExpandedRowId(id === expandedRowId ? null : id);   

        if(window.config.isXMLAPI){ 
            try {  
                    let allRoutingsDetailData = [];  
                    const xhr = new XMLHttpRequest();
                    const url = window.config.API_URL_BO;
                    xhr.open('POST', url, true);  
                    xhr.setRequestHeader('Content-Type', 'text/xml');
                    xhr.onload = function () { 
                    if (xhr.status >= 200 && xhr.status < 300) { 
                        const xmlString = xhr.responseText;
                        const parser = new DOMParser();
                        const xmlDoc = parser.parseFromString(xmlString, 'text/xml');   
                        const itemElements = xmlDoc.getElementsByTagName('RoutingDetail'); 
                        for (let i = 0; i < itemElements.length; i++) { 
                            const item = itemElements[i]; 
                            allRoutingsDetailData.push({'id':i,'PickupPoint':item.getAttribute('PickupPoint'),'PickupDate':item.getAttribute('PickupDate'),
                        'Flight':item.getAttribute('Flight'),'PickupTime':item.getAttribute('PickupTime'),'RefNumber':item.getAttribute('RefNumber'),
                        'Client':item.getAttribute('Client'),'Hotel':item.getAttribute('Hotel'),'PAX':item.getAttribute('PAX'),'participants':item.getAttribute('participants')});
                        }   
                        setdetailData(allRoutingsDetailData); 
                    } else {  
                    }
                    };
                    
                    xhr.send(buildGetWebformRoutingDetails(id));   
                    
                } catch (e) {
                    console.error("Failed to fetch details:", e);
                    alert('Failed to load details. Please check the console.');
                } finally { 
                }
        }else{
                try {  
                  axios.get(window.config.API_URL_BO+"Assignment/RoutingDetails/" +id , { 
                        })
                        .then(response => { 
                           if (response.status === 200) { 

                                let allRoutingsDetailData = [];   
                                response.data.forEach((item,index) => {
                                    allRoutingsDetailData.push({'id':index,'PickupPoint':item.PickupPoint,'PickupDate':item.PickupDate,
                                    'Flight':item.Flight,'PickupTime':item.PickupTime,'RefNumber':item.RefNumber,
                                    'Client':item.Client,'Hotel':item.Hotel,'PAX':item.PAX,'participants':item.participants});
                                
                                });
                                if (allRoutingsDetailData.length > 0){  
                                    setdetailData(allRoutingsDetailData);
                                } 
                           }else{
                                console.error('Request failed error status:', response.status);
                           } 
                        })
                        .catch(error => {
                        console.error('Request failed:', error); 
                        });  
                } catch (err) {
                     console.error("API Polling Error:", err);  
                } finally {  
                }
        }
    }; 

  
   const getUserLocation = (ordernum,platename,client) => { 
    if (navigator.geolocation) { 

        const locationOptions = {
          enableHighAccuracy: true,
          maximumAge: 0 
        };

        navigator.geolocation.getCurrentPosition(
        (position) => { 
          const { latitude, longitude } = position.coords;  
          try {  
                   axios.post(window.config.API_URL_FO+"Coordinates/"+ordernum+"/"+client+"/" +platename +"/"+latitude+"/"+longitude , { 
                        })
                        .then(response => {  
                           if (response.status === 200) {    
                            console.log("writing coordinates..");
                           }else{
                                console.error('Request failed error status:', response.status);
                                clearInterval(intervals.current[ordernum]);
                                delete intervals.current[ordernum]; 
                                setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
                           } 
                        })
                        .catch(error => {
                                        console.error('Request failed:', error); 
                                        clearInterval(intervals.current[ordernum]);
                                        delete intervals.current[ordernum]; 
                                        setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
                        });  
                } catch (err) {
                     console.error("API Polling Error:", err);  
                     clearInterval(intervals.current[ordernum]);
                     delete intervals.current[ordernum];  
                     setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
                } finally {  
                }
        }, 
        (error) => {
          console.error('Error getting user location:', error);
          clearInterval(intervals.current[ordernum]);
          delete intervals.current[ordernum]; 
          setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
        },
        locationOptions
      );
    } 
    else {
      console.error('Geolocation is not supported by this browser.');
      clearInterval(intervals.current[ordernum]);
      delete intervals.current[ordernum]; 
      setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
    }
  };

  const sendcoordinates=(ordernum,plateid) =>{ 
    if (activeBTN[ordernum]){ 
      setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
      if (intervals.current[ordernum]) {
        clearInterval(intervals.current[ordernum]);
        delete intervals.current[ordernum]; 
      }
    }else{
     // if (intervals.current[ordernum]) return; 
      const plate = vehicleData.find(item => parseInt(item.id) === parseInt(plateid));  
      const platename = plate.name;
      const client = localStorage.getItem('AccountID');  
    
      intervals.current[ordernum] = setInterval(() => {
        getUserLocation(ordernum,platename, client)
      }, 5000);
      setactiveBTN(prev => ({ ...prev, [ordernum]: true }));
    }
     
  }

  useEffect(() => {
    return () => {
      Object.values(intervals.current).forEach(clearInterval);
    };
  }, []);

  const isAdmin = localStorage.getItem('isAdmin'); 

  const mappopup=(ordernum) => {
    const url = new URL(window.location.href);
    const baseUrl = url.origin;
    window.open(baseUrl+'/livetrafficstatus?ordernum='+ordernum, '_blank', 'noopener,noreferrer');
  }

  return (
    <div className="policy-card"> 
        <div className="card-detail">
            <label>OrderNum:</label> <span>{route['OrderNum']}</span>
        </div>
        <div className="card-detail">
         <>
                    {isAdmin==='true' && (
                      <FontAwesomeIcon onClick={() => mappopup(route['OrderNum'])}  className='famap' icon={faMap} />
                    )}
        </>
        </div>
        <div className="card-detail">
                  <>
                    {route['Vehicle'] > 0 && (
                       <button 
                        onClick={() => sendcoordinates(route['OrderNum'],route['Vehicle'])}
                        className={activeBTN[route['OrderNum']] ? "Stopbtn" : "startbtn"} 
                        >{activeBTN[route['OrderNum']] ? "Stop" : "Start"}</button>
                    )}
                  </> 
                </div>
        <div className="card-detail">
            <label>Origin:</label> <span>{route['Origin']}</span>
        </div>
        <div className="card-detail">
            <label>Destination:</label> <span>{route['Destination']}</span>
        </div>
        <div className="card-detail">
            <label>Route:</label> <span>{route['Route']}</span>
        </div> 
        <div className="card-detail">
            <label>PickUp Time:</label> <span>{route['PickUpTime']}</span>
        </div>
        <div className="card-detail">
            <label>PAX:</label> <span>{route['PAX']}</span>
        </div>
        <div className="card-detail">
            <label>Transfer Type:</label> <span>{route['TransferType']}</span>
        </div>
        <div className="card-detail">
            <label>Comments:</label> <span>{route['Comments']}</span>
        </div>  
        <div className="card-detail">
             <label>Vehicle:</label> 
             <SearchableVehicleSelect 
                    initialVehicleValue={route['Vehicle']}  
                    vehicleData={vehicleData}  
                    apifunction={vehiclechanged} 
                    orderId={route['OrderNum']}  
                    autoFocus={false}           
                />
        </div>
        <div className="card-detail">
            <label>Arrival Flight:</label> <span>{route['ArrivalFlight']}</span>
        </div>
        <div className="card-detail">
            <label>Departure Flight:</label> <span>{route['DepartureFlight']}</span>
        </div>
        <div className="card-detail">
            <label>Flight Time:</label> <span>{route['DepartureTime']}</span>
        </div> 
        <div className="card-detail">
            <label>Tour Operator:</label> <span>{route['TourOperator']}</span>
        </div>  
        <center><span className='showdetails'   onClick={() => handleToggleDetails(route['OrderNum'])} > {route['OrderNum'] === expandedRowId && ("Hide Details")}{route['OrderNum'] !== expandedRowId && ("Show Details")}</span></center> 
        {route['OrderNum'] === expandedRowId && (
                <tr className="detail-row-container"> 
                    <td colSpan={7} > 
                       <DetailComponentMobile detailData={detailData}></DetailComponentMobile> 
                    </td>
                </tr>  
        )}
    </div>
  );

};

export default MobileGrid;